var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.979 135.844c21.796 0 39.467-17.67 39.467-39.466s-17.67-39.466-39.467-39.466c-21.797 0-39.467 17.67-39.467 39.466s17.67 39.466 39.467 39.466z",
    fill: "#a70b52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.589 110.266h-8.173V79.377h-3.031v33.939h3.031v-.021h8.173v-3.029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.989 97.641H62.637v-3.03H85.97c.031.586.046 1.173.046 1.767 0 18.247-14.792 33.038-33.038 33.038S19.94 114.625 19.94 96.378c0-18.247 14.792-33.038 33.039-33.038.481 0 .961.01 1.438.031l-.004 3.008a31.023 31.023 0 0 0-1.434-.033c-16.586 0-30.033 13.446-30.033 30.032 0 16.587 13.446 30.032 30.033 30.032 16.134 0 29.296-12.721 30.002-28.682l.008-.087z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.655 88.521a4.642 4.642 0 1 0 0-9.285 4.642 4.642 0 0 0 0 9.285z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808183",
    d: "M112.043 115.75h28.201v-8.516h-17.846V76.735h-10.355v39.015zM174.318 79.482c-3.234-2.505-7.396-3.775-12.365-3.775-5.9 0-10.828 1.812-14.254 5.236-3.578 3.579-5.471 8.851-5.471 15.246 0 6.831 2.002 12.597 5.637 16.229 2.852 2.852 6.656 4.359 11.006 4.359 9.551 0 11.748-5.725 11.748-5.725V115.749h8.625V93.714h-17.168v6.895H169.978s.076 8.68-8.08 8.68c-2.072 0-3.918-.752-5.338-2.172-2.213-2.211-3.383-5.936-3.383-10.767 0-8 3.18-12.776 8.504-12.776 3.326 0 5.826 2.042 6.467 5.137h10.984c-.57-4.496-1.804-6.84-4.814-9.229z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLg);
export default __webpack_public_path__ + "static/media/lg.b9e10a75d92766d5e0b933ff40f8ae55.svg";
export { ForwardRef as ReactComponent };